// TODO ECharts GL must be imported whatever component,charts is imported.
import '../../echarts-gl';
import Polygons3DSeries from './Polygons3DSeries';
import Polygons3DView from './Polygons3DView';
export function install(registers) {
  registers.registerChartView(Polygons3DView);
  registers.registerSeriesModel(Polygons3DSeries);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts-gl/lib/chart/polygons3D/install.js
// module id = 1134
// module chunks = 0